import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import { isEmpty, toString } from 'lodash';
import { Toast } from '@kaleyra/emmy'
import i18n from 'i18next';

export const SOUND_DETAILS_LOADING = "SOUND_DETAILS_LOADING";
export const SOUND_DETAILS_SUCCESS = "SOUND_DETAILS_SUCCESS";
export const SOUND_DETAILS_FAILED = "SOUND_DETAILS_FAILED";
export const SOUND_DETAILS_RESET = "SOUND_DETAILS_RESET";
export const SOUND_DETAILS_FILTER = "SOUND_DETAILS_FILTER";
export const SOUND_DETAILS_FILTER_FALSE= "SOUND_DETAILS_FILTER_FALSE";
export const SOUND_PAGINATE_SUCCESS = "SOUND_PAGINATE_SUCCESS";
export const SOUND_PAGINATE_LOADING = "SOUND_PAGINATE_LOADING";



export const SOUND_OP_INIT = "SOUND_OP_INIT";
export const SOUND_OP_SUCCESS = "SOUND_OP_SUCCESS";
export const SOUND_OP_FAILED = "SOUND_OP_FAILED";
export const SOUND_OP_RESET = "SOUND_OP_RESET";

export const SOUND_TYPES_LOADING = "SOUND_TYPES_LOADING"
export const SOUND_TYPES_SUCCESS = "SOUND_TYPES_SUCCESS";
export const SOUND_TYPES_FAILED = "SOUND_TYPES_FAILED";

export const FETCH_CALL_LOGS_LOADING = "FETCH_CALL_LOGS_LOADING";
export const FETCH_CALL_LOGS_SUCCESS = "FETCH_CALL_LOGS_SUCCESS";
export const FETCH_CALL_LOGS_FAILED = "FETCH_CALL_LOGS_FAILED";
export const CLEAR_CALL_LOGS_DETAILS = "CLEAR_CALL_LOGS_DETAILS";
export const FETCH_CALL_LOGS_PAGINATE_SUCCESS = "FETCH_CALL_LOGS_PAGINATE_SUCCESS";
export const FETCH_CALL_LOGS_FILTERED_LOADING = "FETCH_CALL_LOGS_FILTERED_LOADING";
export const FETCH_CALL_LOGS_FILTERED_SUCCESS = "FETCH_CALL_LOGS_FILTERED_SUCCESS";
export const CLEAR_CALL_LOGS_STATUS = "CLEAR_CALL_LOGS_STATUS";

export const CREATE_REPORT_LOADING = "CREATE_REPORT_LOADING"
export const CREATE_REPORT_SUCCESS = "CREATE_REPORT_SUCCESS";
export const CREATE_REPORT_FAILED = "CREATE_REPORT_FAILED";

export const CLEAR_CALL_LOGS_IDS_DETAILS = "CLEAR_CALL_LOGS_IDS_DETAILS";
export const FETCH_CALL_LOGS_IDS_SUCCESS = "FETCH_CALL_LOGS_IDS_SUCCESS";
export const FETCH_CALL_LOG_IDS_LOADING = "FETCH_CALL_LOG_IDS_LOADING";
export const FETCH_CALL_LOGS_IDS_FAILED = "FETCH_CALL_LOGS_IDS_FAILED";
export const FETCH_CALL_LOGS_IDS_LOADING = "FETCH_CALL_LOGS_IDS_LOADING";
export const CLEAR_CALL_LOGS_IDS_STATUS = "CLEAR_CALL_LOGS_IDS_STATUS";

export const getSoundTypes = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: SOUND_TYPES_LOADING });

        let endpoint = `/sound-types`

        networkCall("get", `${endpoint}`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.data) {
                    dispatch({ type: SOUND_TYPES_SUCCESS, payload: { res: res.data } });
                } else {
                    dispatch({ type: SOUND_TYPES_FAILED, payload: { error: res.error } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: SOUND_TYPES_FAILED, payload: { error } });
                }
            });
    }
}

export const getSoundsData = (data: any, filter?: boolean) => {
    const { category, tag_id, title, limit, paginate, page } = data
    return (dispatch: Dispatch<any>) => {

        if(filter===true){
            dispatch({ type: SOUND_DETAILS_FILTER,payload: data })
        }else if(filter===false){
            dispatch({ type: SOUND_DETAILS_FILTER_FALSE })
        }

        if (paginate) {
            dispatch({ type: SOUND_PAGINATE_LOADING })
        } else if(paginate===false && page===0) {
            dispatch({ type: SOUND_DETAILS_LOADING });
        }

        let endpoint = `/sounds?`
        if (limit) { endpoint += `limit=${limit}&offset=${page * limit}&` }
        if (category) { endpoint += `category=${category}&` }
        if (tag_id) { endpoint += `tag_id=${tag_id}&` }
        if (title) { endpoint += `title=${title}` }

        networkCall("get", `${endpoint}`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.data) {
                    if (paginate) {
                        dispatch({ type: SOUND_PAGINATE_SUCCESS, payload: { res: res } })
                    } else {
                        dispatch({ type: SOUND_DETAILS_SUCCESS, payload: { res: res } });
                    }

                 } else {
                    dispatch({ type: SOUND_DETAILS_FAILED, payload: { error: res.error.error } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: SOUND_DETAILS_FAILED, payload: { error } });
                }
            });
    }
}

export const deleteSoundFile = (data: { [key: string]: string }) => {

    return (dispatch: Dispatch<any>) => {
        dispatch({ type: SOUND_OP_INIT });

        let endpoint = `/sounds`

        networkCall("delete", `${endpoint}`, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (res.data) {
                    dispatch({ type: SOUND_OP_SUCCESS, payload: `File deleted successfully.` });
                } else {
                    dispatch({ type: SOUND_OP_FAILED, payload: { error: res.error.error } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: SOUND_OP_FAILED, payload: error.response.data.message });
                }
            });
    }
}

export const addSoundFile = (data: any) => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: SOUND_OP_INIT });
        let url = `/sounds`
        networkCall("post", `${url}`, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (res.data && res.data.length) {
                    dispatch({ type: SOUND_OP_SUCCESS, payload: i18n.t(`File added successfully.`) });
                } else {
                    dispatch({ type: SOUND_OP_FAILED, payload: i18n.t(res.error.file) });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    let msg = error.response.data.message;
                    // if(error.response.status === 400){
                    //     msg = i18n.t("sameSoundNameErrorMsg");
                    // }
                    dispatch({ type: SOUND_OP_FAILED, payload: i18n.t(msg) });
                }
            });
    }
}

export const editSoundFile = (data: any) => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: SOUND_OP_INIT });

        let url = `/sounds`

        networkCall("put", `${url}`, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (res.data && res.data.status === "1") {
                    dispatch({ type: SOUND_OP_SUCCESS, payload: i18n.t('File edited successfully.') });
                } else {
                    dispatch({ type: SOUND_OP_FAILED, payload: { error: i18n.t(res.error.error) } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    let msg = error.response.data.message;
                    // if(error.response.status === 400){
                    //     msg = i18n.t("sameSoundNameErrorMsg");
                    // }
                    dispatch({ type: SOUND_OP_FAILED, payload: i18n.t(msg) });
                }
            });
    }
}
// export const fetchCallLogsDetails = () => {
//     return (dispatch:Dispatch<any>) => {
//         networkCall("get", `/call-logs`, apiBaseUrl.baseUrl)
//         .then((res:any)=>{
//             if(res.error && isEmpty(res.error)){
//                 dispatch({type: FETCH_CALL_LOGS_SUCCESS, payload: {res: res}});
//             }else{
//                 dispatch({type: FETCH_CALL_LOGS_FAILED, payload: {error: res}});
//             }
//         }).catch((error:any)=>{
//             if(error?.response?.data){
//                 dispatch({ type: FETCH_CALL_LOGS_FAILED, payload: {error: error.response.data}});
//             }
//         });
//     }
// }
export const fetchCallLogsDetails = (data: any) => {
    let { limit, offset, paginate, search, total, dateRange, call_type, number, call_status, bridge_numbers, call_id, hangup_status, system_disposition } = data

    return (dispatch: Dispatch<any>) => {

        let loadingType = FETCH_CALL_LOGS_LOADING;
        let successType = FETCH_CALL_LOGS_SUCCESS;

        if (total) {
            loadingType = FETCH_CALL_LOGS_FILTERED_LOADING;
            successType = FETCH_CALL_LOGS_FILTERED_SUCCESS;
        }

        if (paginate && offset > 0) {
            loadingType = "";
            successType = FETCH_CALL_LOGS_PAGINATE_SUCCESS;
        }
        let URL = `/call-logs?`;
        if (limit) {
            URL += `limit=${limit}&offset=${offset * limit}`
        }

        // let URL = `/call-logs?limit=${limit}&offset=${offset * limit}`;
        if (search && search.length) {
            URL += `&to=${search}`;
        }
        if (!isEmpty(dateRange) && dateRange[0]) {
            let date = encodeURIComponent(dateRange.toString())
            URL += `&start_time=${date}`
        }
        if (call_type) {
            if (call_type === 'bridge' && !isEmpty(bridge_numbers)) {
                let bridgeNum = encodeURIComponent(toString(bridge_numbers))
                URL += `&bridge=${bridgeNum}`
            } else if(call_type === 'call_to' && !isEmpty(number)){
                let temp = ''
                number.map((item: string) => temp += `&call_to[]=${item}`)
                URL += temp
            }
            else {
                if (number) {
                    URL += `&${call_type}=${number}`
                }
            }
        }

        console.log('call_id in action???? ',call_id);
        if(!isEmpty(call_id)){
            call_id.forEach( (_id:string) => {
                console.log("Before appending ",_id);
                URL+= `&call_id[]=${_id}`;
            })
            console.log('URL after appending ???? ',URL);
        }
        // if (call_type) {
        //     URL += `&${call_type}=${number}`
        // }

        // if (!isEmpty(bridge_numbers)) {
        //     let bridgeNum = encodeURIComponent(toString(bridge_numbers))
        //     URL += `&bridge=${bridgeNum}`
        // }

        if (!isEmpty(call_status)) {
            let temp = ''
            call_status.map((item: string) => temp += `&status[]=${item}`)
            URL += temp
        }

        if (!isEmpty(hangup_status)) {
            let temp = ''
            hangup_status.map((item: string) => temp += `&hangup_status[]=${item}`)
            URL += temp
        }

        if (!isEmpty(system_disposition)) {
            let temp = ''
            system_disposition.map((item: string) => temp += `&system_disposition[]=${item}`)
            URL += temp
        }

        dispatch({ type: loadingType });
        networkCall("get", URL, apiBaseUrl.baseUrl).then((res: any) => {
            if (res.error && isEmpty(res.error)) {
                dispatch({ type: successType, payload: res });
            } else {
                dispatch({ type: FETCH_CALL_LOGS_FAILED, payload: { error: res } });
            }
        }).catch((err) => {
            if (err?.response?.data) {
                dispatch({ type: FETCH_CALL_LOGS_FAILED, payload: { error: err.response.data } });
            }
        });
    }
}

export const clearCallLogs = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: CLEAR_CALL_LOGS_DETAILS });
    }
}
export const fetchCallLogsIds = (data: any) => {
    let { limit, offset, call_id } = data

    console.log('changing value in fetchCallLogsIds',data);
    return (dispatch: Dispatch<any>) => {

        let loadingType = FETCH_CALL_LOG_IDS_LOADING;
        let successType = FETCH_CALL_LOGS_IDS_SUCCESS;
        let failedType = FETCH_CALL_LOGS_IDS_FAILED;
        let URL = `/call-logs?`;

        if (limit) {
            URL += `limit=${limit}&offset=${offset * limit}`
        }
        console.log('call_id in action???? ',call_id);

        if(call_id) URL+= `&call_id=${call_id}`;
        console.log('URL after appending ???? ',URL);

        dispatch({ type: loadingType });
        networkCall("get", URL, apiBaseUrl.baseUrl).then((res: any) => {
            if (res.error && isEmpty(res.error)) {
                dispatch({ type: successType, payload: res });
            } else {
                dispatch({ type: failedType, payload: { error: res } });
            }
        }).catch((err) => {
            if (err?.response?.data) {
                dispatch({ type: failedType, payload: { error: err.response.data } });
            }
        });
    }
}

export const clearCallLogsIds = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: CLEAR_CALL_LOGS_IDS_DETAILS });
    }
}
export const clearCallLogsStatusState = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: CLEAR_CALL_LOGS_STATUS });
    }
}
export const createReport = (data: any, cb: (message: string) => void) => {
    return (dispatch: Dispatch<any>) => {

        dispatch({ type: CREATE_REPORT_LOADING, payload: {} });

        networkCall("post", "/report", apiBaseUrl.baseUrl, true, true, data).then((res: any) => {
            if (res.error && isEmpty(res.error)) {

                dispatch({ type: CREATE_REPORT_SUCCESS, payload: { res: res.data } });
                let message = "Report extracted successfully."
                cb(message);


            } else {
                dispatch({ type: CREATE_REPORT_FAILED, payload: { error: res } });
            }
        }).catch((error) => {
            if (error?.response?.data) {
                Toast(error.response.data?.error?.title, 'error')
                dispatch({ type: CREATE_REPORT_FAILED, payload: error.response.data?.error?.title });
            }
        });
    }
}
export const createSpeechReport = (data: any, cb: (message: string) => void) => {
    return (dispatch: Dispatch<any>) => {

        dispatch({ type: CREATE_REPORT_LOADING, payload: {} });

        networkCall("post", "/speech", apiBaseUrl.baseUrl, true, true, data).then((res: any) => {
            if (res.error && isEmpty(res.error)) {

                dispatch({ type: CREATE_REPORT_SUCCESS, payload: { res: res.data } });
                let message = "Report extracted successfully."
                cb(message);


            } else {
                dispatch({ type: CREATE_REPORT_FAILED, payload: { error: res } });
            }
        }).catch((error) => {
            if (error?.response?.data) {
                Toast(error.response.data?.error?.title, 'error')
                dispatch({ type: CREATE_REPORT_FAILED, payload: error.response.data?.error?.title });
            }
        });
    }
}
